// extracted by mini-css-extract-plugin
export var crowdedStatusItem = "parking-pin-module--crowdedStatusItem--80d65";
export var currentFee = "parking-pin-module--currentFee--ae191";
export var emptyStatusItem = "parking-pin-module--emptyStatusItem--bc24b";
export var fullStatusItem = "parking-pin-module--fullStatusItem--75065";
export var invalidStatusItem = "parking-pin-module--invalidStatusItem--4072d";
export var selectedPin = "parking-pin-module--selectedPin--2ae78";
export var statusItemText = "parking-pin-module--statusItemText--554c0";
export var unselectedPin = "parking-pin-module--unselectedPin--e4231";